module.exports = __webpack_public_path__ + "static/media/hz_tu5box.7c5288f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hz_tu5box.png
// module id = 1594
// module chunks = 10